import { render, staticRenderFns } from "./NfirsExport.vue?vue&type=template&id=2316fefc&"
import script from "./NfirsExport.vue?vue&type=script&lang=js&"
export * from "./NfirsExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports